<template>
  <CRow v-if="data" class="mr-3">
    <!-- type come from the prop -->
    <!-- if(prop)=> card-type(prop) -->
    <!-- else=> card-normal -->
    <transition appear name="slide" type="animation">
      <template v-if="backgroundIMG !== undefined">
        <CCard
          :class="[
            'mr-2 mt-3 hvr-grow card',
            type ? 'card-' + type : 'card-normal',
          ]"
          :style="backgroundImage"
          @mouseover="hover = true"
          @mouseleave="hover = false"
        >
          <CCardHeader class="card-header">
            <!-- hide the menu icon when users aren't login -->
            <CRow v-if="this.$store.getters['auth/userStatus']">
              <CCol>
                <div class="card-menu" @click="showMenu">
                  <i class="fa fa-ellipsis-h font-xl text-white" />
                </div>
              </CCol>
            </CRow>
            <CRow @click="sendCourseData(data)">
              <CCol
                :class="['card-title', type === 'normal' ? '' : 'text-white']"
                :style="CheckHover"
                >{{ data.controls.title[0].val || "no" }}</CCol
              >
            </CRow>
          </CCardHeader>
          <CCardBody class="card-body pt-0">
            <CContainer @click="sendCourseData(data)" class="p-0">
              <!-- display course name -->
              <CRow>
                <CCol
                  class="text-left font-weight-bolder truncateCourseName"
                  :class="[type === 'normal' ? '' : 'text-white']"
                  :style="CheckHover"
                  >{{ data.controls.name[0].val || "no" }}</CCol
                >
              </CRow>
              <!-- Display study hrs -->
              <CRow>
                <CCol
                  class="text-left description"
                  :class="[type === 'normal' ? '' : 'text-white']"
                  :style="CheckHover"
                  >Study hours:</CCol
                >
                <CCol
                  class="text-right description"
                  :class="[type === 'normal' ? '' : 'text-white']"
                  :style="CheckHover"
                  >{{ data.controls.studyHour }}</CCol
                >
              </CRow>
              <!-- Display category -->
              <CRow v-if="data.controls.categorys.length === 1">
                <CCol
                  class="text-left description"
                  :class="[type === 'normal' ? '' : 'text-white']"
                  :style="CheckHover"
                  >Category</CCol
                >
                <CCol
                  class="text-right description truncateCategory"
                  :class="[type === 'normal' ? '' : 'text-white']"
                  :style="CheckHover"
                >
                  {{
                    $helpers.translate(
                      data.controls.categorys[0].category.title,
                      lang
                    )
                  }}
                  <p class="description"></p>
                </CCol>
              </CRow>
              <CRow v-else-if="data.controls.categorys.length > 2">
                <CCol class="text-left description">Category</CCol>
                <CCol
                  class="text-right description truncateCategory"
                  :style="CheckHover"
                >
                  {{
                    $helpers.translate(
                      data.controls.categorys[0].category.title,
                      lang
                    )
                  }}
                  <br />More...
                </CCol>
              </CRow>
              <!-- display Academic -->
              <CRow>
                <CCol
                  class="text-right description"
                  :class="[type === 'normal' ? '' : 'text-white']"
                  :style="CheckHover"
                  >Academic Year</CCol
                >
                <CCol
                  class="text-right description"
                  :class="[type === 'normal' ? '' : 'text-white']"
                  :style="CheckHover"
                >
                  <p v-if="data">
                    {{ data.controls.academicYear }} /
                    {{ data.controls.semester }}
                  </p>
                  <p v-else>
                    {{ data.controls.academicYear }} /
                    {{ data.controls.semester }}
                  </p>
                </CCol>
              </CRow>
              <!-- display views -->
              <CRow>
                <CCol
                  class="text-left description"
                  :class="[type === 'normal' ? '' : 'text-white']"
                  :style="CheckHover"
                  >Views:</CCol
                >
                <CCol
                  class="text-right description"
                  :class="[type === 'normal' ? '' : 'text-white']"
                  :style="CheckHover"
                >
                  <p v-if="data.views">
                    {{ data.views.length }}
                  </p>
                  <p v-else>0</p>
                </CCol>
              </CRow>
            </CContainer>
            <!-- display progress and button for in-progress card style -->
            <!-- <CRow v-if="type === 'inProgress'" class="mt-3">
              <CCol @click="onclickProgressBarButton('progressbar')">
                <CProgress
                  class="progress-bar"
                  showPercentage
                  :value="progress == null ? 50 : returnProgress(progress)"
                  :max="progressBarMaxValue"
                  show-value
                  border-radius="50px"
                >
                  <CProgressBar
                    v-if="progressZeroPercent == false"
                    style="border-radius: 20px; background-color: #2a4388"
                    >{{
                      progress == null ? "Loading" : progress.toFixed(2) + "%"
                    }}
                  </CProgressBar>
                  <CProgressBar
                    v-else
                    style="border-radius: 20px; background-color: #2a4388"
                    >{{
                      progress == null ? "Loading" : progress.toFixed(2) + "%"
                    }}</CProgressBar
                  >
                </CProgress>
              </CCol>
              <CCol
                class="text-right overviewIcon"
                @click="onclickPlayButton()"
              >
                <img
                  src="@/assets/icons/homepage/GotoOverview.svg"
                  alt="overview"
                  width="43"
                  height="43"
                />
              </CCol>
            </CRow> -->
          </CCardBody>
        </CCard>
      </template>
      <template v-else>
        <CCard
          :class="[
            'mr-2 mt-3 hvr-grow card',
            type ? 'card-' + type : 'card-normal',
          ]"
          :style="backgroundColor"
        >
          <CCardHeader class="card-header">
            <!-- hide the menu icon when users aren't login -->
            <CRow v-if="this.$store.getters['auth/userStatus']">
              <CCol>
                <div class="card-menu" @click="showMenu">
                  <i class="fa fa-ellipsis-h font-xl text-white" />
                </div>
              </CCol>
            </CRow>
            <CRow @click="sendCourseData(data)">
              <CCol
                :class="['card-title', type === 'normal' ? '' : 'text-white']"
                :style="CheckHover"
                >{{ data.controls.title[0].val || "no" }}</CCol
              >
            </CRow>
          </CCardHeader>

          <CCardBody class="card-body pt-0">
            <CContainer @click="sendCourseData(data)" class="p-0">
              <!-- display course name -->
              <CRow>
                <CCol
                  class="text-left font-weight-bolder truncateCourseName"
                  :class="[type === 'normal' ? '' : 'text-white']"
                  >{{ data.controls.name[0].val || "no" }}</CCol
                >
              </CRow>
              <!-- Display study hrs -->
              <CRow>
                <CCol
                  class="text-left description"
                  :class="[type === 'normal' ? '' : 'text-white']"
                  >Study hours:</CCol
                >
                <CCol
                  class="text-right description"
                  :class="[type === 'normal' ? '' : 'text-white']"
                  >{{ data.controls.studyHour }}</CCol
                >
              </CRow>
              <!-- Display category -->
              <CRow v-if="data.controls.categorys.length === 1">
                <CCol
                  class="text-left description"
                  :class="[type === 'normal' ? '' : 'text-white']"
                  >Category:</CCol
                >
                <CCol
                  class="text-right description truncateCategory"
                  :class="[type === 'normal' ? '' : 'text-white']"
                >
                  {{
                    $helpers.translate(
                      data.controls.categorys[0].category.title,
                      lang
                    )
                  }}

                  <p class="description"></p>
                </CCol>
              </CRow>
              <CRow v-else-if="data.controls.categorys.length > 2">
                <CCol class="text-left description">Category</CCol>
                <CCol class="text-right description truncateCategory">
                  {{
                    $helpers.translate(
                      data.controls.categorys[0].category.title,
                      lang
                    )
                  }}
                  <br />More...
                </CCol>
              </CRow>
              <!-- display Academic -->
              <CRow>
                <CCol
                  class="text-left description"
                  :class="[type === 'normal' ? '' : 'text-white']"
                  :style="CheckHover"
                  >Academic Year:</CCol
                >
                <CCol
                  class="text-right description"
                  :class="[type === 'normal' ? '' : 'text-white']"
                  :style="CheckHover"
                >
                  <p v-if="data">
                    {{ data.controls.academicYear }} /
                    {{ data.controls.semester }}
                  </p>
                  <p v-else>
                    {{ data.controls.academicYear }} /
                    {{ data.controls.semester }}
                  </p>
                </CCol>
              </CRow>
              <!-- display views -->
              <CRow>
                <CCol
                  class="text-left description"
                  :class="[type === 'normal' ? '' : 'text-white']"
                  >Views:</CCol
                >
                <CCol
                  class="text-right description"
                  :class="[type === 'normal' ? '' : 'text-white']"
                >
                  <p v-if="data.views">
                    {{ data.views.length }}
                  </p>
                  <p v-else>0</p>
                </CCol>
              </CRow>
            </CContainer>
            <!-- display progress and button for in-progress card style -->
            <!-- <CRow v-if="type === 'inProgress'" class="mt-3">
              <CCol @click="onclickProgressBarButton('progressbar')">
                <CProgress
                  class="progress-bar"
                  showPercentage
                  :value="progress == null ? 50 : returnProgress(progress)"
                  :max="progressBarMaxValue"
                  show-value
                  border-radius="50px"
                >
                  <CProgressBar
                    v-if="progressZeroPercent == false"
                    style="border-radius: 20px; background-color: #2a4388"
                    >{{
                      progress == null ? "Loading" : progress.toFixed(2) + "%"
                    }}</CProgressBar
                  >

                  <CProgressBar
                    v-else
                    style="border-radius: 20px; background-color: #2a4388"
                    >{{
                      progress == null ? "Loading" : progress.toFixed(2) + "%"
                    }}</CProgressBar
                  >
                </CProgress>
              </CCol>
              <CCol
                class="text-right overviewIcon"
                @click="sendCourseData(data)"
              >
                <img
                  src="@/assets/icons/homepage/GotoOverview.svg"
                  alt="overview"
                  width="43"
                  height="43"
                />
              </CCol>
            </CRow> -->
          </CCardBody>
        </CCard>
      </template>
    </transition>

    <!-- for display icon -->
    <transition name="slide" type="animataion">
      <div class="mt-3" v-show="showingMenu">
        <div
          :key="index"
          class="mb-2"
          v-for="(item, index) in menu"
          @click="clickIcon(item.name)"
        >
          <span class="icon-container">
            <img v-if="type === 'favourite'" :src="item.active" width="28" />
            <img v-else :src="item.nonActive" width="28" />
          </span>
        </div>
      </div>
    </transition>
  </CRow>
</template>

<script>
import { mapGetters } from "vuex";
import Service from "../../service/api.js";
// type : normal, favourite, inProgress
export default {
  props: {
    data: Object,
    type: String,
    index: Number,
    // change to receive from backend instead in case of get color from backend
    // For testing only
    backgroundFavouriteCardColor: String,
    backgroundIMG: Object,
    backgroundIMGStatus: Object,
    courseID: String,
  },
  data() {
    return {
      lang: "en",
      progress: null,
      showingMenu: false,
      progressBarMaxValue: 100,
      progressZeroPercent: false,
      menu: [
        {
          name: "star",
          status: false,
          color: "gray",
          active: require("@/assets/icons/cardMenu/favorite.svg"),
          nonActive: require("@/assets/icons/cardMenu/non-favorite.svg"),
          icon: "fas fa-star",
        },
      ],
      hover: false,
      CheckWidth: window.innerWidth.toString(),
    };
  },
  computed: {
    ...mapGetters({
      getCourseChapterAndProgress: "courses/getCourseChapterAndProgress",
    }),
    backgroundColor() {
      if (this.backgroundFavouriteCardColor) {
        return `background-color: ${this.backgroundFavouriteCardColor}`;
      }
      return "no-color";
    },
    backgroundImage() {
      if (this.backgroundIMG) {
        if (this.CheckWidth < 1030) {
          return `background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.73)),url('${this.backgroundIMG.url}') ;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: cover;
                    color: white !important`;
        } else {
          if (this.hover) {
            return `background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.73)),url('${this.backgroundIMG.url}') ;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: cover;
                    color: white !important`;
          } else {
            return "";
          }
        }
      } else {
        return "";
      }
    },
    CheckHover() {
      if (this.CheckWidth < 1030) {
        if (this.hover) {
          return `color: white`;
        } else {
          return "color: white";
        }
      } else {
        if (this.hover) {
          return `color: white`;
        } else {
          return "color: #999999";
        }
      }
    },
  },
  watch: {
    data: function (val) {
      console.log('mdl card is', val);
      
    },
    getCourseChapterAndProgress: function (val) {
      console.log('getCourseChapterAndProgress',val);
      
      if (this.type === "inProgress") {
        if (this.data._id == val.courseId) {
          this.progress = val.progress;
        }
      } else {
      }
    },
  },
  created() {
    if (this.type === "inProgress") {
      // this.$store.dispatch(
      //   "courses/fetchCourseChapterAndProgressHomePage",
      //   this.data._id
      // );
    }
  },
  mounted() {
    console.log('mdl card is', this.data);
    // if (this.$store.getters["auth/userStatus"]) {
    //   this.$store.dispatch("auth/fetchCourseEducation");
    // }
  },
  methods: {
    showMenu() {
      this.showingMenu = !this.showingMenu;
    },
    onclickProgressBarButton(val) {
      this.$emit("progressbar", [
        true,
        this.data._id,
        this.data.controls.name[0].val,
      ]);
    },
    returnProgress(val) {
      // alert(val)
      if (this.progress !== null) {
        if (val <= 30 && val > 0) {
          let newVal = 30;
          return newVal;
        } else if (val == 0) {
          this.progressZeroPercent = true;
          return 30;
        } else {
          return val;
        }
      }
    },
    onclickPlayButton() {
      this.$router.push({
        name: "Overview",
        params: {
          courseCode: this.data.code,
          courseID: this.data._id,
        },
      });
    },
    clickIcon(name) {
      let user_id = this.$store.getters["auth/userInformation"]._id;
      switch (name) {
        case "star":
          let body = {
            course_id: this.data._id,
            user_id: user_id,
          };

          this.showMenu();
          if (this.type === "favourite") {
            this.$store.dispatch("deleteFavoutiteCourse", body);
          } else {
            this.$store.dispatch("addFavoutiteCourse", body);
          }
          break;
          dafault: break;
      }
    },
    sendCourseData(data) {
      let courseCodeData = {
        courseCode: data.code,
        objectId: data._id,
      };
      this.$store.commit("necessary/setDataCourse", courseCodeData);
      // this.$router.push({
      //   name: "Overview",
      //   params: { courseObjectId: data._id }
      // });
      this.$router.push("/Overview/" + data._id);
    },
  },
};
</script>
<style scoped>
.hvr-grow {
  display: inline-block;
  vertical-align: middle;
  transform: translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  backface-visibility: hidden;
  -moz-osx-font-smoothing: grayscale;
  transition-duration: 0.3s;
  transition-property: transform;
}

.hvr-grow:hover,
.hvr-grow:focus,
.hvr-grow:active {
  transform: scale(1.03);
  margin-right: 2em;
}

.description {
  font-size: 0.85rem;
  color: #999999;
  opacity: 1;
}
.card-normal {
  position: relative;
  height: 100%;
  width: 220px;
  border: 0;
  background: #4d4d4d 0% 0% no-repeat padding-box;
  box-shadow: 5px 5px 10px #00000029;
  border-radius: 30px;
  opacity: 1;
}
.card-with-img {
  position: relative;
  height: 235px;
  width: 220px;
  border: 0;
  background: transparent 0% 0% no-repeat padding-box;
  box-shadow: 5px 5px 10px #00000029;
  border-radius: 30px;
  opacity: 1;
}
.card-normal:hover {
  background: #6d6d6d 0% 0% no-repeat padding-box;
}

.card-favourite {
  position: relative;
  height: auto;
  width: 220px;
  border: 0;
  background: #bd2531 0% 0% no-repeat padding-box;
  box-shadow: 5px 5px 10px #00000029;
  border-radius: 30px;
  opacity: 1;
  cursor: pointer;
}
.card-inProgress {
  position: relative;
  width: 260px;
  height: 350px;
  box-shadow: 5px 5px 10px #0000004d;
  background-color: #2a4388;
  border: white;
  border-radius: 30px;
  color: white;
  transition: transform 0.2s;
}

.card-inProgress:hover {
  cursor: pointer;
}

.card-completed {
  background-image: url("../../assets/icons/completed_logo.svg");
  margin-left: 10px;
  background-repeat: no-repeat;
  background-size: 120px;
  background-position: 125px 200px;
  position: relative;
  width: 260px;
  height: 324px;
  -webkit-box-shadow: 5px 5px 10px #0000004d;
  box-shadow: 5px 5px 10px #0000004d;
  background-color: #2a4388;
  border: white;
  border-radius: 30px;
  color: white;
  -webkit-transition: -webkit-transform 0.2s;
  transition: -webkit-transform 0.2s;
  transition: transform 0.2s;
  transition: transform 0.2s, -webkit-transform 0.2s;
}

.card-completed:hover {
  cursor: pointer;
}

.card .card-header {
  padding: 0rem 1.25rem;
  border: 0px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background: transparent;
}

.card .card-header .card-menu {
  z-index: 999;
  margin-right: -0.3rem;
  position: absolute;
  background: #999999;
  opacity: 0.54;
  height: 30px;
  width: 45px;
  text-align: end;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px 30px;
}
.card .card-header .card-menu:hover {
  cursor: pointer;
  opacity: 0.8;
}

.card .card-header .card-title {
  margin-bottom: 0;
  font-size: 4.5rem !important;
  font-weight: Bold;
  letter-spacing: 0px;
  color: #999999;
  opacity: 1;
}

.card .card-body {
  -ms-flex: 1 1 auto;
  -webkit-box-flex: 1;
  flex: 1 1 auto;
  min-height: 1px;
  padding-bottom: 0rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.truncateCategory {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.truncateCourseName {
  width: 5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;

  font-size: 1.12rem;
  margin-bottom: 0.1rem;
  color: #999999;
  opacity: 1;
}

.progress-bar {
  width: 9rem;
  height: 43px;
  border-radius: 50px;
  box-shadow: none;
  padding: 5px;
  overflow: visible;
  background: white;
}

.icon-container {
  border-radius: 50%;
  /* top right bottom left */
  padding: 0.15rem 0rem 0.15rem 0rem;
}

.icon-container:hover {
  cursor: pointer;
}

.slide-enter {
  opacity: 0;
}

.slide-enter-active {
  transition: opacity 0.4s;
  animation: slide-in 0.4s ease-out forwards;
}

.slide-leave-active {
  transition: opacity 0.125s;
  opacity: 0;
  animation: slide-out 0.125s ease-in forwards;
}

@keyframes slide-in {
  from {
    transform: translateX(-1.5rem);
  }
  to {
    transform: translateX(0rem);
  }
}

@keyframes slide-out {
  from {
    transform: translateX(0rem);
  }
  to {
    transform: translateX(-1.5rem);
  }
}
</style>
